import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { KnowledgeUsagedTypes } from 'services/accountConversations/types';
import { SocketStatus } from 'utils/socket';

type WSData = {
  payload: WSPayload;
  type: string;
};

interface PayloadData<T> {
  data: T;
}

type WSPayload = {
  metadata: WSMetadata;
  tokens?: string;
  items?: Array<KnowledgeUsagedTypes>;
  currentUuid?: string;
  answer: string;
  buttons?: string[];
  knowledgeUsaged?: Array<any>
  triggerType: string;
  exportChat: {
    expiresAt: string;
    fileUrl: string;
  }[];
  attachedMedia: {
    fileName: string;
    fileUrl: string;
    source: string;
  }[];
};

type WSMetadata = {
  uuid: string;
  action: string;
  endAiAction: boolean;
  code: string
};

interface SocketState {
  currentUuid: string;
  data: WSData[];
  socketStatus: string;
  token: string;
  currentConversation: string;
}

const initialState: SocketState = {
  currentUuid: '',
  currentConversation: '',
  data: [],
  socketStatus: SocketStatus.DISCONNECTED,
  token: '',
};

export const socketSlice = createSlice({
  name: 'socketReducer',
  initialState,
  reducers: {
    setCurrentUuid: ($state, action: PayloadAction<PayloadData<string>>) => {
      const { data } = action.payload;
      $state.currentUuid = data;
    },
    setCurrentConversaion: ($state, action: PayloadAction<PayloadData<string>>) => {
      const { data } = action.payload;
      $state.currentConversation = data;
    },
    receiveData: ($state, action: PayloadAction<WSData>) => {
      const data = action.payload;
      if (data?.payload?.metadata.uuid === $state.currentUuid
        || data?.payload?.metadata.uuid === $state.currentConversation) {
        const temp = [...$state.data];
        $state.data = [...temp, data];
      }
      if (!$state.currentUuid) {
        $state.currentUuid = data?.payload?.metadata.uuid;
      }
    },
    resetData: ($state) => {
      $state.data = [];
    },
    setSocketStatus: ($state, action: PayloadAction<string>) => {
      $state.socketStatus = action.payload;
    },
    setCurrentChatbotAccessToken: (
      $state,
      action: PayloadAction<PayloadData<string>>,
    ) => {
      const { data } = action.payload;
      $state.token = data;
    },
  },
  extraReducers() { },
});

export default socketSlice.reducer;
export const {
  setCurrentUuid,
  receiveData,
  resetData,
  setSocketStatus,
  setCurrentChatbotAccessToken,
  setCurrentConversaion
} = socketSlice.actions;
